module.exports = __webpack_public_path__ + "img/生日有礼.a44f77f8.svg";